import { H1 } from '@repo/ui/h1'
import { Loader2 } from 'lucide-react'
import { useEffect, useState } from 'react'

export function LoadingRoute() {
  const [show, setShow] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true)
    }, 100)

    return () => clearTimeout(timer)
  }, [])

  if (!show) return null
  return (
    <div className="flex h-full flex-1 flex-col items-center justify-center">
      <H1 className="text-primary mb-4">CaseAi</H1>
      <Loader2 className="text-primary-300 h-12 w-12 animate-spin" />
    </div>
  )
}
